export default __webpack_public_path__ + "static/media/race_of_the_reapers_3.e1dd9950.png";